import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HeroVoice = () => {
  const [voice, setVoice] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stories/voice-of-week`).then((r) => setVoice(r.data.voice || null)).catch(() => setVoice(null));
  }, []);

  if (!voice) return null;
  const signature = [voice.name, voice.role].filter(Boolean).join(", ");

  return (
    <motion.blockquote
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2.0, duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
      className="border-l-2 border-emerald-400/60 pl-4 max-w-md"
      data-testid="hero-voice"
    >
      <div className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#78716C] flex items-center gap-2 mb-2"><Quote size={11} className="text-emerald-300" /> Voice of the week</div>
      <p className="font-display italic text-lg md:text-xl leading-snug text-[#1C1917]" data-testid="hero-voice-quote">“{voice.quote}”</p>
      {signature && <footer className="font-mono text-[9px] tracking-[0.22em] uppercase text-[#78716C] mt-2" data-testid="hero-voice-name">— {signature}</footer>}
    </motion.blockquote>
  );
};
